





















import {Component, Vue} from 'vue-property-decorator';
import List from '@/components/List.vue';
import {namespace} from 'vuex-class';
import {Base} from '@/models/base';
const tag = namespace('tag');
@Component({
  components: {List},
})
export default class Tags extends Vue {
  @tag.State
  private tags!: Base[];

  @tag.Action
  private fetchTags!: () => Promise<void>;

  mounted() {
    this.fetchTags();
  }
}
